/** @format */

/**
 * 会话分析筛选类型定义。
 * Filters 数组中每项为 FilterMtchProps（文本匹配）或 FilterRangeValueProps（数值区间），
 * 通过是否存在 Op 字段区分类型。
 */

import { FilterMtchProps } from '../TraceAnalysis/typescript'

/** 文本条件操作符，与 Trace 分析一致 */
export type MatchMode = 'in' | 'not_in'

/** 数值区间筛选，Key 对应后端字段名（如 cost、total_tokens） */
export interface FilterRangeValueProps {
  /** 筛选字段名，与 ListAppMonitorSessions 请求 Filters 中的 Key 一致 */
  Key: string
  /** 区间下限，null 表示未填写 */
  Start: number | null
  /** 区间上限，null 表示未填写 */
  End: number | null
}

/** 单条筛选条件：文本匹配或数值区间 */
export type SessionFilterItem = FilterMtchProps | FilterRangeValueProps

/** 是否为文本匹配项（含 Op、Values） */
export function isSessionMatchFilter(item: SessionFilterItem): item is FilterMtchProps {
  return 'Op' in item
}

/** 是否为数值区间项（含 Start、End） */
export function isSessionRangeFilter(item: SessionFilterItem): item is FilterRangeValueProps {
  return !('Op' in item)
}

/** 按 Key 取文本匹配项 */
export function getSessionMatchFilter(
  filters: SessionFilterItem[],
  key: string
): FilterMtchProps | undefined {
  return filters.find((f): f is FilterMtchProps => isSessionMatchFilter(f) && f.Key === key)
}

/** 按 Key 取数值区间项 */
export function getSessionRangeFilter(
  filters: SessionFilterItem[],
  key: string
): FilterRangeValueProps | undefined {
  return filters.find((f): f is FilterRangeValueProps => isSessionRangeFilter(f) && f.Key === key)
}

/** 会话列表查询参数（对应 ListAppMonitorSessions） */
export interface SessionAnalysisSearchProps {
  Page?: number
  PageSize?: number
  Order?: string
  OrderBy?: string
  /** 侧栏筛选条件，提交前会过滤掉空值项 */
  Filters: SessionFilterItem[]
}

/** 会话分析列表单行（ListAppMonitorSessions.Sessions 项） */
export interface SessionAnalysisListItem {
  SessionId: string
  ServiceName: string
  UserId: string
  TotalTokens: number
  InputTokens: number
  OutputTokens: number
  CacheReadTokens: number
  TraceCount: number
  ErrorCount: number
  /** 会话耗时，单位毫秒 */
  DurationMs: number
  StartTime: string
  EndTime: string
  LastActiveTime: string
}
